import { ContactAutofill } from '@wix/ambassador-forms-v4-form/types';
import { FIELD_TYPES } from '@wix/form-fields';
const AUTOFILL_FIELDS = [{
  fieldType: FIELD_TYPES.CONTACTS_EMAIL,
  key: 'email'
}, {
  fieldType: FIELD_TYPES.CONTACTS_FIRST_NAME,
  key: 'firstName'
}, {
  fieldType: FIELD_TYPES.CONTACTS_LAST_NAME,
  key: 'lastName'
}, {
  fieldType: FIELD_TYPES.CONTACTS_PHONE,
  key: 'phone'
}];
export function autofillValues(form, values, config) {
  const result = {
    ...values
  };
  const userData = config == null ? void 0 : config.userData;
  if (!userData || (form == null ? void 0 : form.autoFillContact) !== ContactAutofill.MEMBER_DATA) {
    return result;
  }
  const fields = (form == null ? void 0 : form.fields) ?? [];
  for (const {
    fieldType,
    key
  } of AUTOFILL_FIELDS) {
    var _userData$key, _fields$find;
    const value = (_userData$key = userData[key]) == null ? void 0 : _userData$key.trim();
    if (!value) {
      continue;
    }
    const target = (_fields$find = fields.find(field => {
      var _field$view;
      return ((_field$view = field.view) == null ? void 0 : _field$view.fieldType) === fieldType;
    })) == null ? void 0 : _fields$find.target;
    if (target && (result[target] == null || result[target] === '')) {
      result[target] = value;
    }
  }
  return result;
}
//# sourceMappingURL=autofill.js.map